<div class="web-login-wrapper">
	<div class="web-login-left">
		<div class="logo-container">
			<img src="assets/images/Logo-KeFirma.png" alt="KeFirma Logo" />
		</div>
		<div class="web-login-card">

			@if (loginError()) {
				<div class="error-message">Credenziali non valide. Riprova.</div>
			}

			<form (ngSubmit)="login()">
				<div class="form-group">
					<label for="username">Username</label>
					<div class="input-wrapper">
						<input type="text" id="username" name="username" [ngModel]="username()" (ngModelChange)="username.set($event)" placeholder="test@mail.com" required />
					</div>
				</div>

				<div class="form-group">
					<label for="password">Password</label>
					<div class="input-wrapper">
						<input [type]="showPassword() ? 'text' : 'password'" id="password" name="password" [ngModel]="password()" (ngModelChange)="password.set($event)" placeholder="••••••••••••••" required />
						<i class="bi" [class.bi-eye]="!showPassword()" [class.bi-eye-slash]="showPassword()" (click)="showPassword.set(!showPassword())" class="toggle-password"></i>
					</div>
				</div>

				<button type="submit" class="btn-login" [disabled]="loading()">
					<span>ACCEDI</span>
				</button>

				<a href="javascript:void(0)" (click)="goToRecuperaPassword()" class="forgot-password">Hai dimenticato la password?</a>

				<div class="separator-container">
					<div class="separator-line"></div>
					<div class="separator-text">oppure</div>
					<div class="separator-line"></div>
				</div>

				<button type="button" class="btn-microsoft" (click)="loginMicrosoft()" [disabled]="loading()">
					<img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21'%3E%3Cpath fill='%23f25022' d='M1 1h9v9H1z'/%3E%3Cpath fill='%237fba00' d='M11 1h9v9h-9z'/%3E%3Cpath fill='%2300a4ef' d='M1 11h9v9H1z'/%3E%3Cpath fill='%23ffb900' d='M11 11h9v9h-9z'/%3E%3C/svg%3E" alt="Microsoft" />
					<span>Accedi con Microsoft</span>
				</button>

			</form>
		</div>
	</div>

	<div class="web-login-right">
		<div class="illustration-container">
			<img src="assets/images/Kefirma-Solutions.png" alt="KeFirma Illustration" />
		</div>
	</div>
</div>
